
import React from "react";
import {
  LayoutDashboard,
  AlertTriangle,
  FilePlus,
  CalendarCheck,
  Fuel,
  UserCog,
  BarChart,
  PieChart,
  TrendingUp,
  Edit,
  MapPin,
  ShieldCheck,
  Ship,
  FileSearch,
  Cpu,
  ChartPie,
  CalendarDays,
  ChartNoAxesCombined,
  CalendarRange,
  Calendar1,
  AppWindow,
  Wrench,
  GaugeCircle,
  Upload,
  Settings2,
  ClipboardList,
  BarChart3,
  CalendarClock,
  FileText,
  Users,
  FileCheck2,
  Image,
  LayoutDashboardIcon,
  LucideLayoutDashboard,
  Info,
  BookX,
  Database,
  BarChartBig,
  Grid,
  WrenchIcon,
  LineChart,
  CheckCheck,
  LockOpen,
  PenToolIcon,
  SettingsIcon,
  MapPinCheck,
  Home,
  FileBarChart,
  DatabaseBackup,
  DatabaseZap,
  DatabaseZapIcon,
  Activity
} from "lucide-react";
import { Menu } from "antd";
import { NavLink } from "react-router-dom";
import "./styles.css";

const { SubMenu } = Menu;

export const superadmin = [
  {
    id: 1,
    label: "Dashboard",
    path: "/superadmin",
    icon: <LayoutDashboard size={20} className="me-2" />,
  },

  {
    id: 2,
    label: "Power Admin",
    path: "/superadmin/owner-settings",
    icon: <Settings2 size={20} className="me-2" />, // Settings for admin users
  },

  {
    id: 3,
    label: "Ships",
    path: "/superadmin/ship-register",
    icon: <Ship size={20} className="me-2" />,
  },

  {
    id: 4,
    label: "Charts",
    path: "/superadmin/chart-management",
    icon: <BarChart3 size={20} className="me-2" />, // Clearer chart icon
  },

  {
    id: 5,
    label: "Events",
    path: "/superadmin/event-management",
    icon: <CalendarClock size={20} className="me-2" />, // More event-specific
  },

  {
    id: 11,
    label: "Templates",
    path: "/superadmin/email-templates",
    icon: <FileText size={20} className="me-2" />, // Email/doc icon
  },

  {
    id: 6,
    label: "Users",
    path: "/superadmin/manage-users",
    icon: <Users size={20} className="me-2" />, // Better for multiple users
  },
  {
    id: 13,
    label: "Excel",
    path: "/superadmin/excel",
    icon: <BookX size={20} className="me-2" />, // Better for multiple users
  },
  {
    id: 7,
    label: "Module Builder",
    path: "/superadmin/module-builder",
    icon: <AppWindow size={20} className="me-2" />, // Represents apps/modules
  },

  {
    id: 8,
    label: "Customize Builder",
    path: "/superadmin/customize-module",
    icon: <Wrench size={20} className="me-2" />, // Customization tool icon
  },

  {
    id: 9,
    label: "BenchMarks",
    icon: <GaugeCircle size={20} className="me-2" />, // Performance/benchmark icon
    path: "/superadmin/benchmarks",
  },

  {
    id: 10,
    label: "Upload",
    icon: <Upload size={20} className="me-2" />,
    path: "/superadmin/upload-data",
  },

  {
    id: 11,
    label: "Admin Settings",
    icon: <Settings2 size={20} className="me-2" />, // Reusing settings for admin
    path: "/superadmin/admin-settings",
  },

];


export const adminItem = [
  {
    id: 1,
    label: "Dashboard",
    path: "/management",
    icon: <LayoutDashboard size={20} className="me-2" />,
  },
  {
    id: 9,
    label: "Ships",
    path: "/management/ship-details",
    icon: <Ship size={20} className="me-2" />,
  },
  {
    id: 3,
    label: "Fleet tracking",
    path: "/management/map-location",
    icon: <MapPin size={20} className="me-2" />,
  },

  {
    id: 6,
    label: "Chart Reports",
    path: "/management/charts",
    icon: <BarChart size={20} className="me-2" />,
    children: [
      { key: 1, label: "Daily Report ", path: "/management/charts/DAILY" },
      { key: 2, label: "Monthly Report", path: "/management/charts/MONTHLY" },
    ],
  },

  {
    id: 6,
    label: "Processed Reports",
    path: "/management/process-data",
    icon: <Cpu size={20} className="me-2" />,
  },

  {
    id: 7,
    label: "Daily Report Calendar",
    path: "/management/event-calendar",
    icon: <CalendarCheck size={20} className="me-2" />,
  },
  {
    id: 7,
    label: "Data workbench",
    path: "/management/user-data",
    icon: <FilePlus size={20} className="me-2" />,
  },
];

export const higherOfficer = [
  {
    id: 1,
    key: "Ship Details",
    label: "Ship Details",
    path: "/admin/shipinfo",
    icon: <Ship size={20} className="me-2" />,
  },
  {
    id: 2,
    key: "Benchmarks",
    path: "/admin/benchmarks",
    label: "Benchmarks",
    icon: <TrendingUp size={20} className="me-2" />,
  },
  {
    id: 3,
    key: "User Management",
    label: "User Management",
    path: "/admin",
    icon: <UserCog size={20} className="me-2" />,
  },
  {
    id: 4,
    key: "Report Sent details",
    label: "Report Sent details",
    path: "/admin/sent-report",
    icon: <FilePlus size={20} className="me-2" />,
  },
  {
    id: 5,
    key: "Access Management",
    label: "Review Manager",
    icon: <UserCog size={20} className="me-2" />,
    path: "/admin/review-page",
  },
];

export const ownerMenus = [
  {
    id: 1,
    label: "Overview",
    path: "/management",
    icon: <Home size={20} className="me-2" />,
  },
  {
    id: 2,
    label: "Dashboard",
    path: "/management/dashboard",
    icon: <LayoutDashboardIcon size={20} className="me-2" />,

    children: [
      {
        key: 1,
        label: "Dashboard ",
        icon: <Ship size={18} />,
        path: "/management/dashboard",
      },
      {
        id: 9,
        label: "Daily Report Calendar",
        path: "/management/event-calendar",
        icon: <CalendarCheck size={20} className="me-2" />,
      },
    ]
  },
  {
    id: 3,
    label: "Administration",
    icon: <ShieldCheck size={20} className="me-2" />,
    path: "/management/administration",
  },
  {
    id: 4,
    label: "Ship Warnings & Alerts",
    path: "/management/ship-warnings",
    icon: <AlertTriangle size={20} className="me-2" />,

  },

  {
    id: 6,
    label: "Fleet tracking",
    path: "/management/map-location",
    icon: <MapPinCheck size={20} className="me-2" />,
  },
  {
    id: 7,
    label: "Chart Reports",
    path: "/management/charts",
    icon: <FileBarChart size={20} className="me-2" />,
    children: [
      {
        key: 1,
        label: "Executive Summary",
        icon: <FileText size={18} />,
        path: "/management/executve-summary",
      },

      {
        key: 3,
        label: "Daily Report",
        icon: <CalendarDays size={18} />,
        path: "/management/charts/DAILY",
      },
      {
        key: 4,
        label: "Monthly Report",
        icon: <CalendarCheck size={18} />,
        path: "/management/charts/MONTHLY",
      },

    ],
  },

  {
    id: 8,
    label: "Processed Reports",
    path: "/management/process-data",
    icon: <DatabaseZapIcon size={20} className="me-2" />,
    children: [
      {
        id: 8,
        label: "Processed Reports",
        path: "/management/process-data",
        icon: <Cpu size={20} className="me-2" />,
      },
      {
        id: 13,
        label: "Data Analytics",
        path: "/management/data-analytics",
        icon: <ChartNoAxesCombined size={20} className="me-2" />,
      },
    ]
  },


  {
    id: 10,
    label: "Data workbench",
    path: "/management/user-data",
    icon: <Database size={20} className="me-2" />,
  },


  {
    id: 11,
    label: "Hull Maintainance",
    path: "/management/hull-data",
    icon: <WrenchIcon size={20} className="me-2" />,

  },
  {
    id: 12,
    label: "Engine Predictive Maintainance",
    path: "/management/engine-predictives",
    icon: <Activity size={20} className="me-2" />,

  },


  {
    id: 14,
    label: "Benchmark",
    path: "/management/benchmarks",
    icon: <TrendingUp size={20} className="me-2" />,
  },
  {
    id: 14,
    label: "Validations",
    path: "/management/addvalidationrules",
    icon: <CheckCheck size={20} className="me-2" />,
  },
  {
    id: 15,
    label: "Permissions",
    path: "/management/permission",
    icon: <LockOpen size={20} className="me-2" />,
  },
];